import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "legend-container" }
const _hoisted_2 = { class: "legend-list" }
const _hoisted_3 = {
  key: 0,
  class: "embfooter__status__list"
}

import { computed, ref, toRefs } from 'vue';
import { ComparedSvgFooterData, FooterData } from '@/types/footer';
import MinusFillIcon from '@/assets/icons/MinusIcon.vue';
import PlusFillIcon from '@/assets/icons/PlusIcon.vue';
import { Amenity } from '@/types';
import { SalesLandFooterOrder } from '@/constant';
import SoldPendingStatus from '@/assets/icons/SoldPendingStatus.vue';
import SoldContingencyStatus from '@/assets/icons/SoldContengencyStatus.vue';
import AmenityIcon from '@/assets/icons/AmenityIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Legend',
  props: {
    data: {},
    selectedNeighborhoodIds: {},
    amenities: {},
    matchedSvgfooterData: {}
  },
  emits: ['setLegends'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { selectedNeighborhoodIds, data, matchedSvgfooterData, amenities } =
  toRefs(props);
const emit = __emit;
const isOpen = ref(true);

const matchLegendItemWithSvg = (footerData: FooterData[]): FooterData[] => {
  return footerData
    .map((item) => {
      const matchedData = matchedSvgfooterData.value.filter((d) =>
        d.status.includes(item.status.toLowerCase())
      );

      const neighborhoods = matchedData.map((d) => d.neighborhood_code);
      return { ...item, neighborhoods };
    })
    .filter((item) => item.neighborhoods.length > 0);
};

const sortItems = (updateFooterData: FooterData[]): FooterData[] => {
  const sorted: FooterData[] = [];
  for (const order of SalesLandFooterOrder) {
    const found = updateFooterData.find((el) => el.status === order);
    if (found) sorted.push(found);
  }
  return sorted;
};

const legendItems = computed(() => {
  let filtered = matchLegendItemWithSvg(data.value);

  if (selectedNeighborhoodIds.value.length) {
    filtered = filtered.filter((d) =>
      d.neighborhoods.some((n) => selectedNeighborhoodIds.value.includes(n))
    );
  }

  filtered = sortItems(filtered);

  const legendArr = filtered.map((plan) => plan.status).toString();
  emit('setLegends', legendArr);

  return filtered;
});

const toggleLegend = () => {
  isOpen.value = !isOpen.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "legend-header",
      onClick: toggleLegend
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Legend", -1)),
      _createElementVNode("span", null, [
        (isOpen.value)
          ? (_openBlock(), _createBlock(MinusFillIcon, { key: 0 }))
          : (_openBlock(), _createBlock(PlusFillIcon, { key: 1 }))
      ])
    ]),
    _withDirectives(_createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legendItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          (item.status === 'Sold Pending')
            ? (_openBlock(), _createBlock(SoldPendingStatus, {
                key: 0,
                svgClass: "color-box"
              }))
            : (item.status === 'Sold Contingency')
              ? (_openBlock(), _createBlock(SoldContingencyStatus, {
                  key: 1,
                  svgClass: "color-box"
                }))
              : (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "color-box",
                  style: _normalizeStyle({
            backgroundColor: item.color,
          })
                }, null, 4)),
          _createTextVNode(" " + _toDisplayString(item.status === 'QMI' ? 'Quick Move-In' : item.status), 1)
        ]))
      }), 128)),
      (_unref(amenities)?.length)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createVNode(AmenityIcon),
            _cache[1] || (_cache[1] = _createTextVNode(" Amenity ", -1))
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, isOpen.value]
    ])
  ]))
}
}

})